import { AuthPopup } from '@teams/views/auth-popup/AuthPopup';
import { TabConfig } from '@teams/views/tab-config/TabConfig';
import { ChatInput, ChatInputProps } from '@terminal/components/chat';
import { lazyComponentLoader } from '@terminal/utils/component-loader/componentLoader';
import React from 'react';

export const teamsPaths = {
  alfred: '/app/alfred',
  insights: '/app/insights',
  config: '/app/config',
  authPopup: '/app/login',
  notFound: '*',
} as const;

// Render prop injected by the terminal's View.tsx — replicate it here so
// Alfred and its sub-components (ExpMobileResearch, Research, etc.) receive it.
const renderChatInput = (props?: ChatInputProps) => <ChatInput {...props} />;

// Reuse the existing terminal views directly — no duplication
const Alfred = lazyComponentLoader(
  () =>
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: "alfred" */ '@terminal/views/alfred'
    ),
  'alfred'
);

const Insights = lazyComponentLoader(
  () =>
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: "insights" */ '@terminal/views/explore'
    ),
  'insights'
);

export interface TeamsRoute {
  path: string;
  element: React.ReactElement;
  isPublic?: boolean;
}

export const tabRoutes: TeamsRoute[] = [
  {
    path: teamsPaths.alfred,
    element: <Alfred renderChatInput={renderChatInput} />,
  },
  {
    path: teamsPaths.insights,
    element: <Insights renderChatInput={renderChatInput} />,
  },
];

export const publicRoutes: TeamsRoute[] = [
  {
    path: teamsPaths.config,
    element: <TabConfig />,
    isPublic: true,
  },
  {
    path: teamsPaths.authPopup,
    element: <AuthPopup />,
    isPublic: true,
  },
];
